var _inkscapePathEffect, _inkscapePathEffect2, _inkscapePathEffect3, _inkscapePathEffect4, _inkscapePathEffect5, _inkscapePathEffect6, _inkscapePathEffect7, _feGaussianBlur, _sodipodiNamedview;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLobitos(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg1",
    width: 74.666664,
    height: 78.666664,
    viewBox: "0 0 74.666664 78.666664",
    sodipodiDocname: "lobitos.svg",
    inkscapeVersion: "1.3 (0e150ed6c4, 2023-07-21)",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  }, _inkscapePathEffect || (_inkscapePathEffect = /*#__PURE__*/React.createElement("inkscapePath-effect", {
    effect: "bspline",
    id: "path-effect7",
    is_visible: "true",
    lpeversion: 1.3,
    weight: 33.333333,
    steps: 2,
    helper_size: 0,
    apply_no_weight: "true",
    apply_with_weight: "true",
    only_selected: "false",
    uniform: "false"
  })), _inkscapePathEffect2 || (_inkscapePathEffect2 = /*#__PURE__*/React.createElement("inkscapePath-effect", {
    effect: "bspline",
    id: "path-effect6",
    is_visible: "true",
    lpeversion: 1.3,
    weight: 33.333333,
    steps: 2,
    helper_size: 0,
    apply_no_weight: "true",
    apply_with_weight: "true",
    only_selected: "false",
    uniform: "false"
  })), _inkscapePathEffect3 || (_inkscapePathEffect3 = /*#__PURE__*/React.createElement("inkscapePath-effect", {
    effect: "bspline",
    id: "path-effect5",
    is_visible: "true",
    lpeversion: 1.3,
    weight: 33.333333,
    steps: 2,
    helper_size: 0,
    apply_no_weight: "true",
    apply_with_weight: "true",
    only_selected: "false",
    uniform: "false"
  })), _inkscapePathEffect4 || (_inkscapePathEffect4 = /*#__PURE__*/React.createElement("inkscapePath-effect", {
    effect: "bspline",
    id: "path-effect4",
    is_visible: "true",
    lpeversion: 1.3,
    weight: 33.333333,
    steps: 2,
    helper_size: 0,
    apply_no_weight: "true",
    apply_with_weight: "true",
    only_selected: "false",
    uniform: "false"
  })), _inkscapePathEffect5 || (_inkscapePathEffect5 = /*#__PURE__*/React.createElement("inkscapePath-effect", {
    effect: "bspline",
    id: "path-effect1",
    is_visible: "true",
    lpeversion: 1.3,
    weight: 33.333333,
    steps: 2,
    helper_size: 0,
    apply_no_weight: "true",
    apply_with_weight: "true",
    only_selected: "false",
    uniform: "false"
  })), _inkscapePathEffect6 || (_inkscapePathEffect6 = /*#__PURE__*/React.createElement("inkscapePath-effect", {
    effect: "bspline",
    id: "path-effect4-2",
    is_visible: "true",
    lpeversion: 1.3,
    weight: 33.333333,
    steps: 2,
    helper_size: 0,
    apply_no_weight: "true",
    apply_with_weight: "true",
    only_selected: "false",
    uniform: "false"
  })), _inkscapePathEffect7 || (_inkscapePathEffect7 = /*#__PURE__*/React.createElement("inkscapePath-effect", {
    effect: "bspline",
    id: "path-effect1-8",
    is_visible: "true",
    lpeversion: 1.3,
    weight: 33.333333,
    steps: 2,
    helper_size: 0,
    apply_no_weight: "true",
    apply_with_weight: "true",
    only_selected: "false",
    uniform: "false"
  })), /*#__PURE__*/React.createElement("filter", {
    inkscapeCollect: "always",
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter6",
    x: -0.20258694,
    y: -0.18928335,
    width: 1.4055855,
    height: 1.3823437
  }, _feGaussianBlur || (_feGaussianBlur = /*#__PURE__*/React.createElement("feGaussianBlur", {
    inkscapeCollect: "always",
    stdDeviation: 0.00012382603,
    id: "feGaussianBlur6"
  })))), _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview1",
    pagecolor: "#ffffff",
    bordercolor: "#000000",
    borderopacity: 0.25,
    inkscapeShowpageshadow: 2,
    inkscapePageopacity: 0,
    inkscapePagecheckerboard: 0,
    inkscapeDeskcolor: "#d1d1d1",
    showgrid: "false",
    inkscapeZoom: 10.334746,
    inkscapeCx: 37.398113,
    inkscapeCy: 32.173021,
    "inkscapeWindow-width": 1920,
    "inkscapeWindow-height": 1009,
    "inkscapeWindow-x": -8,
    "inkscapeWindow-y": -8,
    "inkscapeWindow-maximized": 1,
    "inkscapeCurrent-layer": "layer1"
  })), /*#__PURE__*/React.createElement("g", {
    inkscapeGroupmode: "layer",
    inkscapeLabel: "Image",
    id: "g1",
    style: {
      display: "none",
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("image", {
    width: 74.666664,
    height: 78.666664,
    preserveAspectRatio: "none",
    style: {
      imageRendering: "optimizeQuality"
    },
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAA7CAYAAAAuEkmwAAAAAXNSR0IArs4c6QAAAARnQU1BAACx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\n3dMlaBncBWAAAAAASUVORK5CYII=\n",
    id: "image1"
  })), /*#__PURE__*/React.createElement("g", {
    inkscapeGroupmode: "layer",
    id: "layer1",
    inkscapeLabel: "Image 1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 1,
      mixBlendMode: "normal",
      fill: "none",
      fillOpacity: 0.501961,
      stroke: "#efcb4e",
      strokeWidth: 12.65563629,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1,
      filter: "url(#filter6)"
    },
    d: "m 33.366406,39.284951 c -4.080087,3.934946 -9.434194,11.933853 -10.901711,17.739547 -1.467517,5.805694 0.951459,9.418031 5.789579,11.304871 4.838121,1.886841 12.095048,2.048106 17.271791,0.177355 5.176742,-1.870751 8.273031,-5.773365 7.515024,-11.595228 -0.758007,-5.821862 -5.370187,-13.562584 -9.079386,-17.497531 -3.709198,-3.934947 -6.51521,-4.063959 -10.595297,-0.129014 z",
    id: "path5",
    "inkscapePath-effect": "#path-effect6",
    "inkscapeOriginal-d": "m 34.640425,35.220991 c -5.354106,7.998906 -10.708213,15.997813 -16.06232,23.996719 2.419073,3.612482 4.838048,7.224819 7.257073,10.837228 7.257217,0.161272 14.514144,0.322537 21.771217,0.483805 3.096412,-3.90277 6.192701,-7.805384 9.289052,-11.708077 C 52.283082,51.089634 47.670902,43.348912 43.058629,35.608035 40.252505,35.479018 37.446493,35.350006 34.640425,35.220991 Z",
    transform: "matrix(1.0950122,0,0,1.0821393,-4.1534177,-5.6266599)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#efcb4e",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.51181,
      strokeDasharray: "none",
      strokeOpacity: 0.501961
    },
    d: "m 10.950115,20.352058 c -3.0479717,0.935356 -7.8214155,5.289511 -8.7406628,9.772858 -0.9192473,4.483348 2.0157178,9.095436 5.0314949,10.272718 3.0157769,1.177282 6.1120039,-1.080383 7.6924649,-4.321941 1.580461,-3.241557 1.644965,-7.466618 1.016007,-10.821064 -0.628959,-3.354447 -1.951333,-5.837928 -4.999304,-4.902571 z",
    id: "path1",
    "inkscapePath-effect": "#path-effect1",
    "inkscapeOriginal-d": "m 12.675686,16.933169 c -4.7735427,4.354245 -9.5469865,8.7084 -14.3206224,13.06273 2.935141,4.612365 5.8701062,9.224453 8.8052478,13.836818 3.0964126,-2.257801 6.1926396,-4.515466 9.2890526,-6.773267 0.06451,-4.225314 0.129013,-8.450375 0.193522,-12.675687 -1.322426,-2.483581 -2.644799,-4.967062 -3.9672,-7.450594 z",
    sodipodiNodetypes: "cccccc"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#efcb4e",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.51181,
      strokeDasharray: "none",
      strokeOpacity: 0.501961
    },
    d: "M 31.558478,1.679608 C 29.479823,0.4515541 25.190189,1.1933705 22.771117,4.3220371 20.352045,7.4507037 19.803755,12.965859 20.432714,16.35256 c 0.628959,3.386702 2.435127,4.644569 4.12846,5.273516 1.693333,0.628946 3.27373,0.628946 4.676776,0.09675 1.403047,-0.532196 2.628638,-1.596525 3.288136,-3.75515 0.659498,-2.158625 0.752828,-5.411372 0.865716,-8.6367297 0.112887,-3.2253578 0.24533,-6.4232845 -1.833324,-7.6513383 z",
    id: "path4",
    "inkscapePath-effect": "#path-effect4",
    "inkscapeOriginal-d": "M 33.769576,-0.29028291 C 29.479823,0.45155417 25.190189,1.1933705 20.900368,1.9352193 20.352045,7.4507037 19.803755,12.965859 19.255432,18.481344 c 1.806241,1.257918 3.612409,2.515785 5.418614,3.773678 1.580461,0 3.160858,0 4.741287,0 1.225664,-1.064392 2.451255,-2.128721 3.676917,-3.193112 0.09333,-3.252859 0.186664,-6.505606 0.279996,-9.7583975 0.132443,-3.197924 0.264886,-6.3958507 0.39733,-9.59379541 z",
    sodipodiNodetypes: "cccccccc"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#efcb4e",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.51181,
      strokeDasharray: "none",
      strokeOpacity: 0.501961
    },
    d: "m 10.950115,20.352058 c -3.0479717,0.935356 -7.8214155,5.289511 -8.7406628,9.772858 -0.9192473,4.483348 2.0157178,9.095436 5.0314949,10.272718 3.0157769,1.177282 6.1120039,-1.080383 7.6924649,-4.321941 1.580461,-3.241557 1.644965,-7.466618 1.016007,-10.821064 -0.628959,-3.354447 -1.951333,-5.837928 -4.999304,-4.902571 z",
    id: "path1-4",
    "inkscapePath-effect": "#path-effect1-8",
    "inkscapeOriginal-d": "m 12.675686,16.933169 c -4.7735427,4.354245 -9.5469865,8.7084 -14.3206224,13.06273 2.935141,4.612365 5.8701062,9.224453 8.8052478,13.836818 3.0964126,-2.257801 6.1926396,-4.515466 9.2890526,-6.773267 0.06451,-4.225314 0.129013,-8.450375 0.193522,-12.675687 -1.322426,-2.483581 -2.644799,-4.967062 -3.9672,-7.450594 z",
    sodipodiNodetypes: "cccccc",
    transform: "matrix(-1,0,0,1,75.374748,0.07688563)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#efcb4e",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.51181,
      strokeDasharray: "none",
      strokeOpacity: 0.501961
    },
    d: "M 31.558478,1.679608 C 29.479823,0.4515541 25.190189,1.1933705 22.771117,4.3220371 20.352045,7.4507037 19.803755,12.965859 20.432714,16.35256 c 0.628959,3.386702 2.435127,4.644569 4.12846,5.273516 1.693333,0.628946 3.27373,0.628946 4.676776,0.09675 1.403047,-0.532196 2.628638,-1.596525 3.288136,-3.75515 0.659498,-2.158625 0.752828,-5.411372 0.865716,-8.6367297 0.112887,-3.2253578 0.24533,-6.4232845 -1.833324,-7.6513383 z",
    id: "path4-5",
    "inkscapePath-effect": "#path-effect4-2",
    "inkscapeOriginal-d": "M 33.769576,-0.29028291 C 29.479823,0.45155417 25.190189,1.1933705 20.900368,1.9352193 20.352045,7.4507037 19.803755,12.965859 19.255432,18.481344 c 1.806241,1.257918 3.612409,2.515785 5.418614,3.773678 1.580461,0 3.160858,0 4.741287,0 1.225664,-1.064392 2.451255,-2.128721 3.676917,-3.193112 0.09333,-3.252859 0.186664,-6.505606 0.279996,-9.7583975 0.132443,-3.197924 0.264886,-6.3958507 0.39733,-9.59379541 z",
    sodipodiNodetypes: "cccccccc",
    transform: "matrix(-1,0,0,1,75.374748,0.07688563)",
    inkscapeLabel: "path4-5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLobitos);
export default __webpack_public_path__ + "static/media/lobitos.6b6e7ebd7c4c3906d2ccc17a50d5e46d.svg";
export { ForwardRef as ReactComponent };